import React from 'react';
import { Github, Instagram, Mail, MapPin, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
    return (
        <footer className="bg-[#0A0A0A] border-t border-white/5">
            <div className="max-w-[1400px] mx-auto px-6 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
                    {/* Brand */}
                    <div className="lg:col-span-2">
                        <div className="flex items-baseline gap-1 mb-4">
                            <span className="text-2xl font-display font-bold text-white">ENIGMA</span>
                            <span className="text-lg font-display font-bold text-[#FF991C]">'26</span>
                        </div>
                        <p className="text-white/40 text-sm leading-relaxed max-w-md mb-6">
                            The ultimate inter-school tech symposium organized by the Computer Club of Seth M.R. Jaipuria School, Goel Campus. Where innovation meets competition.
                        </p>
                        <div className="flex gap-3">
                            {[
                                { icon: Instagram, href: 'https://instagram.com' },
                                { icon: Github, href: 'https://github.com' },
                                { icon: Mail, href: 'mailto:enigma@jsgc.in' },
                            ].map((social, i) => (
                                <a
                                    key={i}
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:text-[#FF991C] hover:border-[#FF991C]/30 transition-all"
                                >
                                    <social.icon className="w-5 h-5" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Links */}
                    <div>
                        <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Quick Links</h4>
                        <ul className="space-y-3">
                            {[
                                { name: 'Events', path: '/events' },
                                { name: 'Code of Conduct', path: '/code-of-conduct' },
                                { name: 'Instructions', path: '/instructions' },
                                { name: 'Venue Map', path: '/venue-map' },
                            ].map((link) => (
                                <li key={link.path}>
                                    <Link
                                        to={link.path}
                                        className="text-white/40 hover:text-white text-sm transition-colors inline-flex items-center gap-1 group"
                                    >
                                        {link.name}
                                        <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Contact</h4>
                        <div className="space-y-4">
                            <div className="flex items-start gap-3">
                                <MapPin className="w-5 h-5 text-[#EF4444] shrink-0 mt-0.5" />
                                <p className="text-white/40 text-sm leading-relaxed">
                                    Seth M.R. Jaipuria School,<br />Goel Campus, Lucknow
                                </p>
                            </div>
                            <div className="flex items-center gap-3">
                                <Mail className="w-5 h-5 text-[#7C4DFF] shrink-0" />
                                <a href="mailto:enigma@jsgc.in" className="text-white/40 hover:text-white text-sm transition-colors">
                                    enigma@jsgc.in
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom */}
                <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-white/30 text-xs">
                        © 2026 ENIGMA JSGC. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        {['Privacy', 'Terms', 'Code of Conduct'].map((item, i) => (
                            <Link
                                key={i}
                                to={`/${item.toLowerCase().replace(/ /g, '-')}`}
                                className="text-white/30 hover:text-white text-xs transition-colors"
                            >
                                {item}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};
